﻿
import React from 'react';

export const decodeEntities = (() => {
  var element = document.createElement('div');

  const decodeHTMLEntities = (str) => {
    if (str && typeof str === 'string') {
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = '';
    }

    return str;
  }

  return decodeHTMLEntities;
})();

export const HtmlOutput = ({ html }) => {
  return (
    <span dangerouslySetInnerHTML={{ __html: html }}></span>
  );
}